import { EActionTypes } from '../../actions/managementCompany';
import { TReduxActions } from '../../types/redux';
import { IManagementCompanyState } from '../../types/redux/managementCompany';

export const initialState: IManagementCompanyState = {
  data: null,
};

export const managementCompanyReducer = (state = initialState, action: TReduxActions) => {
  if (action.type === EActionTypes.SetManagementCompany) {
    return {
      ...state,
      data: action.payload,
    };
  }

  return state;
};
